var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-tabs',{on:{"tab-click":_vm.handleClick},model:{value:(_vm.activeName),callback:function ($$v) {_vm.activeName=$$v},expression:"activeName"}},[_c('div',{staticClass:"main-content"},[_c('div',[_c('el-image',{staticStyle:{"width":"579px"},attrs:{"src":"https://oss.yanxin7.cn/2023-08-25/ec25847d987e1d1871f6a83c87c370c3"}})],1)])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }